import layout from '@/layout'

export default {
  path: '/sys',
  component: layout,
  redirect: '/user/manage',
  name: 'roleManage',
  meta: {
    title: '系统管理',
    icon: 'system'
  },
  children: [
    {
      path: '/user/role',
      component: () => import('@/views/sys/role-list/index'),
      meta: {
        title: '角色列表',
        icon: 'permissions'
      }
    }
  ]
}
